export default "__VITE_ASSET__8cfee13e__"